---
title: "What's new in March"
date: "2026-03-23"
---

We've been busy! This release brings smarter predictions, powerful new admin tools, a refreshed look, and plenty of quality-of-life improvements. Here's everything that's new.

---

## <IconHeading icon="PenLine">Improved Add & Edit Entry</IconHeading>

The add and edit entry dialogs have been rebuilt for a smoother workflow:

- **Better search** — matter, task, and activity search is faster and more accurate, with fuzzy matching so you don't need exact names
- **Tab navigation** — press **Tab** to move between fields without reaching for the mouse

---

## <IconHeading icon="Replace">Custom Abbreviations</IconHeading>

Type a shorthand in any narrative field and press **Space** — it expands instantly. Try it:

<AbbreviationDemo />

*The abbreviations above are for demonstration only. Create and manage your own in [Settings](/settings/abbreviations).*

---

## <IconHeading icon="ShieldAlert">Restricted Words</IconHeading>

Flagged language is now highlighted directly in the narrative as you type. **Warnings** (amber) can still be saved; **blocked** words (red) must be removed before submitting. Hover any highlight to see details:

<RestrictedWordsDemo />

If a blocked word is found on submit, you can fix it manually or click **Fix with AI** to rephrase automatically.

*The rules above are for demonstration only. Your firm's restricted words are configured by your admin.*

---

## <IconHeading icon="UserCog">Settings Under Profile</IconHeading>

Settings, Support, FAQ, and What's New now live under your profile menu in the sidebar footer:

<ProfileMenuDemo />

---

## <IconHeading icon="Palette">Custom Appearance</IconHeading>

Personalize how Hourglass looks in [Settings](/settings/appearance):

- **Theme** — Light, Dark, or System (follows your OS)
- **Style** — Hourglass (brand colors) or Standard
- **Contrast** — Regular or High Contrast
- **Text Size** — Small, Medium, or Large

---

## <IconHeading icon="Brain">Smarter Matter Prediction</IconHeading>

Matter prediction is now more accurate. The matching engine uses deeper context from document titles, email subjects, and file content to assign the right matter — so you'll see fewer blanks and fewer wrong guesses.

> **Heads up:** Complex entries with ambiguous context may take a moment longer to resolve. This is the tradeoff for higher accuracy — Hourglass would rather take an extra second than assign the wrong matter.

> **Update:** Some issues with matter prediction were resolved in the [Early April Update](/updates/2026-04-02#bug-fixes--stability).

---

## <IconHeading icon="Wrench">Bug Fixes & Stability</IconHeading>

- Countless bug fixes across the application for a smoother day-to-day experience.
- General stability improvements.

---

That's it for March. As always, [contact support](/support) if you have questions about any of these changes.
